import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { KibAdminGuard } from './guards/kib-admin.guard';
import { KibGuard } from './guards/kib.guard';
import { KibComponent } from './kib.component';

const kibTitleResolver: ResolveFn<string> = () => {
  const translateSrv = inject(TranslateService);
  return translateSrv.get('kib.title').pipe(map((res: string) => `RGS+ | ${res}`));
};

export const kibRoutes: Routes = [
  {
    path: 'kib',
    canActivate: [KibGuard],
    component: KibComponent,
    title: kibTitleResolver,
    children: [
      {
        path: 'user-list',
        loadComponent: () => import('./pages/user/user-list/user-list.component').then((m) => m.UserListComponent),
        canActivate: [KibAdminGuard],
        children: [
          {
            path: ':mode',
            loadComponent: () =>
              import('./pages/user/user-dialog/user-dialog.component').then((m) => m.UserDialogComponent),
          },
          {
            path: ':mode/:id',
            loadComponent: () =>
              import('./pages/user/user-dialog/user-dialog.component').then((m) => m.UserDialogComponent),
          },
        ],
      },
      {
        path: 'client-list',
        loadComponent: () =>
          import('./pages/client/client-list/client-list.component').then((m) => m.ClientListComponent),
        children: [
          {
            path: ':mode',
            loadComponent: () =>
              import('./pages/client/client-dialog/client-dialog.component').then((m) => m.ClientDialogComponent),
          },
          {
            path: ':mode/:id',
            loadComponent: () =>
              import('./pages/client/client-dialog/client-dialog.component').then((m) => m.ClientDialogComponent),
          },
        ],
      },
      {
        path: 'inspection-method-list',
        loadComponent: () =>
          import('./pages/inspection-method/inspection-method-list/inspection-method-list.component').then(
            (m) => m.InspectionMethodListComponent,
          ),
        children: [
          {
            path: ':mode',
            loadComponent: () =>
              import('./pages/inspection-method/inspection-method-dialog/inspection-method-dialog.component').then(
                (m) => m.InspectionMethodDialogComponent,
              ),
          },
          {
            path: ':mode/:id',
            loadComponent: () =>
              import('./pages/inspection-method/inspection-method-dialog/inspection-method-dialog.component').then(
                (m) => m.InspectionMethodDialogComponent,
              ),
          },
        ],
      },
      {
        path: 'api-account-list',
        canActivate: [KibAdminGuard],
        loadComponent: () =>
          import('./pages/api-account/api-account-list/api-account-list.component').then(
            (m) => m.ApiAccountListComponent,
          ),
        children: [
          {
            path: ':mode',
            loadComponent: () =>
              import('./pages/api-account/api-account-dialog/api-account-dialog.component').then(
                (m) => m.ApiAccountDialogComponent,
              ),
          },
          {
            path: ':mode/:id',
            loadComponent: () =>
              import('./pages/api-account/api-account-dialog/api-account-dialog.component').then(
                (m) => m.ApiAccountDialogComponent,
              ),
          },
        ],
      },
      {
        path: 'inspection-list-list',
        loadComponent: () =>
          import('./pages/inspection-list/inspection-list-list/inspection-list-list.component').then(
            (m) => m.InspectionListListComponent,
          ),
        children: [
          {
            path: ':mode',
            loadComponent: () =>
              import('./pages/inspection-list/inspection-list-dialog/inspection-list-dialog.component').then(
                (m) => m.InspectionListDialogComponent,
              ),
          },
          {
            path: ':mode/:id',
            loadComponent: () =>
              import('./pages/inspection-list/inspection-list-dialog/inspection-list-dialog.component').then(
                (m) => m.InspectionListDialogComponent,
              ),
          },
        ],
      },
      {
        path: 'inspection-list-item-list/:id',
        loadComponent: () =>
          import('./pages/inspection-list/inspection-list-item-list/inspection-list-item-list.component').then(
            (m) => m.InspectionListItemListComponent,
          ),
        children: [
          {
            path: ':mode/:tab',
            loadComponent: () =>
              import('./pages/inspection-list/inspection-list-item-dialog/inspection-list-item-dialog.component').then(
                (m) => m.InspectionListItemDialogComponent,
              ),
          },
          {
            path: ':mode/:tab/:id',
            loadComponent: () =>
              import('./pages/inspection-list/inspection-list-item-dialog/inspection-list-item-dialog.component').then(
                (m) => m.InspectionListItemDialogComponent,
              ),
          },
        ],
      },
    ],
  },
];
